import { makeStyles } from '@material-ui/core';
import colors from '../../../../abstracts/colours';

export const useStyles = makeStyles({
  indicator: {
    backgroundColor: colors.scienceBlue,
  },
});
